export default __webpack_public_path__ + "static/media/ic_angola.e1547730.svg";